// extracted by css-extract-rspack-plugin
export default {"root":"src-components-Day15Forecast-Day15Forecast-module__root-u8k6Oe","header":"src-components-Day15Forecast-Day15Forecast-module__header-KFr5YO","contentContainer":"src-components-Day15Forecast-Day15Forecast-module__contentContainer-qzTrNe","grid":"src-components-Day15Forecast-Day15Forecast-module__grid-gy5gxG","gridItem":"src-components-Day15Forecast-Day15Forecast-module__gridItem-_ZqgXK"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-Day15Forecast-Day15Forecast-module__root-u8k6Oe\",\"header\":\"src-components-Day15Forecast-Day15Forecast-module__header-KFr5YO\",\"contentContainer\":\"src-components-Day15Forecast-Day15Forecast-module__contentContainer-qzTrNe\",\"grid\":\"src-components-Day15Forecast-Day15Forecast-module__grid-gy5gxG\",\"gridItem\":\"src-components-Day15Forecast-Day15Forecast-module__gridItem-_ZqgXK\"}";
        // 1772473572995
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  